<template>
  <div  class="col pl-2 col-md-6 details docs-details pr-0 photo-documentation-content" id="preview-docs">
   <preview-cover-content
    :theme="theme"
    :logo_one="logoOne"
    :logo_two="logoTwo"
    :project="project"
    :project_img="projectImg"
    :selectedDocument="selectedDocument"/>

    <text-area-content
      :textPage="textPage"
      :logo_one="logoOne"
      :logo_two="logoTwo"
      :selectedDocument="selectedDocument"
      :theme="theme"/>

    <preview-photos-content
      :theme="theme"
      :logo_one="logoOne"
      :logo_two="logoTwo"
      :selectedDocument="selectedDocument"/>

  </div>
</template>
<script>

import PreviewCoverContent from './PreviewCoverContent'
import TextAreaContent from './PreviewTextAreaContent'
import PreviewPhotosContent from './PreviewPhotosContent'
import {mapState} from 'vuex'
export default {
  components: {
    PreviewCoverContent,
    TextAreaContent,
    PreviewPhotosContent
  },
  created () {
    if (this.logoOne === '' || !this.logoTwo){
      this.$store.dispatch("getProjectDetails",this.$route.params.id)
    }
  },
  computed: {
    ...mapState({
      selectedDocument: state => state.photoDocumentation.selectedDocument,
      theme: state => state.photoDocumentation.selectedTemplate,
      project: state => state.appSettings.project,
      logoOne: state => state.appSettings.logoOne,
      logoTwo: state => state.appSettings.logoTwo,
      projectImg: state => state.appSettings.projectImage,
    }),

    textPage () {
      return false
    },

  }
}
</script>

<style scoped>
h1 , h2 , h3 , h4 {
  margin-bottom: 7px;
}
.details .stickynav ul li{
  padding: 5px 10px;
  margin: 0 1px;
  background: rgba(190, 159, 159, 0.36);
  border: 1px solid blanchedalmond;
}
.details .stickynav ul li{
  padding: 5px 10px;
  margin: 0 1px;
}
.c-sliding-pagination__list-element--active ,.c-sliding-pagination__list-element--active a{
  background: #2c6ed5 !important;
  color: white !important;
}
.docs-details{
  height: calc(100vh - 142px);
  overflow-y: auto;
}
.docs-details::-webkit-scrollbar-track{
  border-radius: 10px;
  background-color: #ffffff;
}
.docs-details::-webkit-scrollbar-thumb{
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.6);
  background-color: #3399ff9e;
  opacity: 1;
}
.docs-details::-webkit-scrollbar{
  width: 9px;
  background-color: #ffffff;
}

[contenteditable] {
  outline: 0 solid transparent;
}
.innerdoc .header{
  min-height: 4rem;
}
nav.pages-nav{
  max-width: 4rem;
  position: fixed;
  right: 0;
  top: 50%;
}
nav.pages-nav ul li a{
  padding: 9px 16px 9px 13px;
  margin-bottom: 1px;
  border-color: #3399ffb0;
  background: #ffffffa6;
  font-size: 1.2rem;
  font-family: monospace;
}
</style>



// WEBPACK FOOTER //
// src/components/photoDocumentation/components/Preview/Preview.vue